import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
    connect,
    Provider,
} from 'react-redux';
import { bindActionCreators } from 'redux';

import { createHashHistory as createHistory } from 'history';

import initReactApp, { extractParams } from 'helpers/InitHelpers';

import configureStore from './Store';

import {
    initialState,
    reducerName,
    initCMPApp,
} from './reduxModules/ConsentManagementPlatform';

import GodBuster from '../components/GodBuster';

import WidgetBanner from './components/Widget/WidgetBanner';

export const appSelector = '#js-app-cmp-widget';

const propTypes = {
    AppActions: PropTypes.shape({
        initCMPApp: PropTypes.func.isRequired,
    }).isRequired,
    history: PropTypes.object.isRequired,
    location: PropTypes.object,
};

const defaultProps = {
    location: {},
};

class WidgetCMP extends Component {

    componentDidMount() {
        const { AppActions } = this.props;
        AppActions.initCMPApp();
    }

    render() {
        return (
            <GodBuster>
                <WidgetBanner />
            </GodBuster>
        );
    }

}

WidgetCMP.propTypes = propTypes;

WidgetCMP.defaultProps = defaultProps;

function mapStateToProps() {
    return {};
}

const ConnectedApp = connect(mapStateToProps, (dispatch) => ({
    AppActions: bindActionCreators({
        initCMPApp,
    }, dispatch),
}))(WidgetCMP);

export default ConnectedApp;

export function initCMPWidgetApp() {
    if (!document.querySelector(appSelector)) return;
    const params = extractParams(appSelector);
    const history = createHistory();
    const store = configureStore({
        [reducerName]: initialState,
    }, history);
    initReactApp(appSelector, (
        <Provider store={store}>
            <ConnectedApp
                history={history}
                /* eslint-disable-next-line react/jsx-props-no-spreading */
                {...params}
            />
        </Provider>
    ));
}

initCMPWidgetApp();
